module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageNumbers > 0) ? _c('ul', {
    staticClass: "m-pagination"
  }, _vm._l((_vm.pageNumbers), function(page) {
    return _c('li', {
      staticClass: "m-pagination__item",
      class: [page == (_vm.pageNo + 1) ? 'm-pagination__item--active' : '']
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.changePage(page - 1)
        }
      }
    }, [_vm._v("\n            " + _vm._s(page) + "\n        ")])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a71ac82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Paginator.vue
// module id = 1678
// module chunks = 0